import { createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "../authSlice";

export const isRegistered = createAsyncThunk<any, any, { rejectValue: { message: string } }>(
    "auth/isRegistered",
    async (email: string, thunkAPI) => {
        try {
            const response = await fetch(`${API}/v1/users/is_registered`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    email
                })
            });

            let data = await response.json();

            if (response.status === 200) {
                return true;
            } else if (response.status === 404) {
                return false;
            } else {
                throw new Error(data.message);
            }
        } catch (error: any) {
            return thunkAPI.rejectWithValue({ message: error.message });
        }
    }
);